import { IdentifiableObjectDTO } from '@dto/IdentifiableObjectDTO';

export class HealthConditionAnswerDTO extends IdentifiableObjectDTO<number> {
  public question: string;

  public answers: string;
}